import type { TourConfig } from '../types';

export const draftEditorTour: TourConfig = {
  name: 'draftEditor',
  autoStart: true,
  steps: [
    {
      target: '[data-tour="video-player"]',
      title: 'Video Player',
      content:
        'Preview your video draft here. Click to play/pause, or use Space key. Arrow keys let you seek forward/backward.',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour="timeline-controls"]',
      title: 'Playback Controls',
      content:
        'Control playback speed, volume, and zoom level. Press ? to see all keyboard shortcuts, or L to locate the playhead.',
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '[data-tour="editor-timeline"]',
      title: 'Timeline',
      content:
        'Navigate through your video using the timeline. Click anywhere to jump to that position. The plus button below the playhead lets you add feedback at that moment.',
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '[data-tour="issues-panel"]',
      title: 'Issues Panel',
      content:
        'View all feedback from your team here. Issues are organized by timestamp. Switch to "Fields" tab to see video metadata like resolution and bitrate.',
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '[data-tour="create-issue-button"]',
      title: 'Add Feedback',
      content:
        'Type your feedback here and submit. It will be tied to the current timestamp. Click the pencil icon to draw annotations on the video.',
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '[data-tour="share-button"]',
      title: 'Share & Collaborate',
      content:
        'Share this draft with your team or external reviewers. Generate public links or keep it private within your team.',
      placement: 'bottom',
      disableBeacon: true,
    },
  ],
};
